import { createVanIconComponent } from "./van"

const Edit = createVanIconComponent("edit")
export default Edit
